import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  confirmSubmitFormNoticeTitle: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.confirm-submit-form-notice-title',
    defaultMessage: 'Submit ‘{formName}’ form',
    description: 'The title of the confirmation modal checking that the user wants to submit the form.'
  },
  confirmSubmitFormNoticeBody: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.confirm-submit-notice-body',
    defaultMessage: 'Customer edits will close once this form is submitted.',
    description: 'The content of the confirmation modal checking that the user wants to submit the form.'
  },
  confirmSubmitFormNoticeBodyNonJsm: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.confirm-submit-notice-body-non-jsm',
    defaultMessage: 'Edits will close once this form is submitted.',
    description: 'The content of the confirmation modal checking that the user wants to submit the form (non JSM project).'
  },
  noticeCancelSubmitLabel: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.notice-cancel-submit-label',
    defaultMessage: 'Cancel',
    description: 'The label for the cancel button on the submit form notice.'
  },
  noticeConfirmSubmitLabel: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.notice-confirm-submit-label',
    defaultMessage: 'Submit form',
    description: 'The label for the confirm button on the submit form notice.'
  },
  submitSuccessFlagTitle: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.submit-success-flag-title',
    defaultMessage: 'Form submitted',
    description: 'The title of the flag indicating that the form submission success.'
  },
  submitFailedFlagTitle: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.submit-failed-flag-title',
    defaultMessage: 'Error: Submitting form failed',
    description: 'The title of the flag indicating that the form submission failed.'
  },
  submitFailedFlagDescription: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.submit-failed-flag-description',
    defaultMessage: 'A server error occurred while trying to submit the form.',
    description: 'The description of the flag indicating that the form submission failed.'
  },
  validationFailedFlagTitle: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.validation-failed-flag-title',
    defaultMessage: 'We couldn’t submit this form',
    description: 'The title of the flag indicating that the form contains validation errors and can not be submitted.'
  },
  validationFailedFlagDescription: {
    id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.validation-failed-flag-description',
    defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
    description: 'The description of the flag indicating that the form contains validation errors and can not be submitted.'
  }
});